import React, { FC, HTMLAttributes } from "react";
import { ElAnchor, ElAnchorButton, EllogoImg, EllogoLink, ElMenu, ElMenuItem, ElFooter, ElFooterContent, ElDescription, ElMenuLeft } from "./footer.css";
import { Container } from "../container";
import { Images } from "../../../@assets/images";
import { Icons } from "../../icons";
import { faFacebook, faInstagram, faTwitter, faYoutube } from "@fortawesome/free-brands-svg-icons";

interface IFooterProps extends HTMLAttributes<HTMLElement> {}

export const Footer: FC<IFooterProps> = ({ children, ...props }) => {
  return (
    <ElFooter {...props}>
      <Container>
        <ElFooterContent>
          <ElMenuLeft>
            <EllogoLink href="/">
              <EllogoImg src={Images.logo} />
            </EllogoLink>
            <ElDescription>
              Program yang dirangkai untuk memberikan solusi dalam meningkatkan inovasi di industri ekonomi kreatif, membangun ekosistem digital dan memberikan kesempatan baru bagi masyarakat.
            </ElDescription>
          </ElMenuLeft>
          <ElMenu>
            <ElMenuItem>
              <ElAnchor href="https://www.facebook.com/bekup.kemenparekraf/">
                <Icons icon={faFacebook} color="#10575C" size="2x" />
              </ElAnchor>
            </ElMenuItem>
            <ElMenuItem>
              <ElAnchor href="https://www.instagram.com/bekup.baparekraf/">
                <Icons icon={faInstagram} color="#10575C" size="2x" />
              </ElAnchor>
            </ElMenuItem>
            <ElMenuItem>
              <ElAnchor href="https://twitter.com/Kemenparekraf">
                <Icons icon={faTwitter} color="#10575C" size="2x" />
              </ElAnchor>
            </ElMenuItem>
            <ElMenuItem>
              <ElAnchor href="https://www.youtube.com/@Kemenparekraf">
                <Icons icon={faYoutube} color="#10575C" size="2x" />
              </ElAnchor>
            </ElMenuItem>
          </ElMenu>
        </ElFooterContent>
      </Container>
    </ElFooter>
  );
};
